import { IRestfulConfigMap } from "../../common/data-access/restful/restful-config-map";
import { envConfig } from "../../environments/env-config";

let builderUrlServiceConfig: IRestfulConfigMap = {
    "builderUrlService": {
        appPath: envConfig.appPath("cgp"),
        isAuth: true,
        actions: {
            "getBuilderUrl": {
                method: "GET",
                path: "api/builder/resource/builder/:idType/:id/url/latest?builderType=:builderType&language=:language",
                paramDefaults: {
                    idType:"@idType",
                    id: "@id",
                    builderType:"@builderType",
                    language:"@language"
                }
            },
            //*TODO - 原有 获取Builder地址
            get:{
                method: "GET",
                path: "api/builder/resource/:builderType/url/latest?:idType=:id&platform=PC&language=:language",
                paramDefaults: {
                    idType:"@idType",
                    builderType:"@builderType",
                    id: "@id",
                    language:"@language"
                }
            }
        }
    }
}


type ActionKey = "getBuilderUrl" | "get";

export { builderUrlServiceConfig };

export type { ActionKey };